import { render, staticRenderFns } from "./SNumberinput.vue?vue&type=template&id=f2111288"
import script from "./SNumberinput.vue?vue&type=script&lang=js"
export * from "./SNumberinput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports